import React from 'react';
import {
  Autocomplete,
  Divider,
  FormControl,
  Grid,
  Stack,
  SxProps,
  Typography,
} from '@mui/material';

import {
  TPAutoCompleteArrowIconComponent,
  TPTextField,
} from '../../../../components/Inputs';
import { countriesOptions, TP_COLORS } from '../../../../constants';
import { textFieldProps, TSelectChange, TState } from '.';

export const editButtonStyles: SxProps = {
  fontWeight: '600',
  padding: '10px 20px',
  color: '#94A3B8',
};

export const deleteButtonStyles: SxProps = {
  fontWeight: '600',
  padding: '10px 20px',
  color: TP_COLORS.orange.light,
};

interface BankDetailsProps {
  state: TState;
  setState: React.Dispatch<React.SetStateAction<TState>>;
}

const BankDetails: React.FC<BankDetailsProps> = ({ state, setState }) => {
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.currentTarget;

    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSelectChange = (
    event: React.SyntheticEvent<Element, Event>,
    value: TSelectChange | null,
    name: string
  ) => {
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <>
      <Divider flexItem sx={{ borderStyle: 'dashed', margin: '24px 0px' }} />
      <Stack
        flexDirection="row"
        justifyContent="space-between"
        marginBottom="24px"
      >
        <Typography variant="h6" fontSize="18px">
          Bank Details
        </Typography>
      </Stack>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={6}>
          <FormControl fullWidth>
            <Autocomplete
              size="small"
              value={state.bankCountry}
              options={countriesOptions}
              onChange={(event, value) =>
                handleSelectChange(event, value, 'bankCountry')
              }
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              popupIcon={TPAutoCompleteArrowIconComponent}
              renderInput={(params) => (
                <TPTextField
                  {...params}
                  {...textFieldProps}
                  size="small"
                  label="Country"
                  placeholder="Country"
                />
              )}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <FormControl fullWidth>
            <TPTextField
              {...textFieldProps}
              name="bankName"
              size="small"
              label="Bank Name"
              placeholder="Bank Name"
              value={state.bankName}
              onChange={handleInputChange}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <FormControl fullWidth>
            <TPTextField
              {...textFieldProps}
              name="bankCode"
              size="small"
              label="Bank Code"
              placeholder="Bank Code"
              value={state.bankCode}
              onChange={handleInputChange}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <FormControl fullWidth>
            <TPTextField
              {...textFieldProps}
              name="branchCode"
              size="small"
              label="Branch Code"
              placeholder="Branch Code"
              value={state.branchCode}
              onChange={handleInputChange}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <FormControl fullWidth>
            <TPTextField
              {...textFieldProps}
              name="bankBranch"
              size="small"
              label="Branch Name"
              placeholder="Branch Name"
              value={state.bankBranch}
              onChange={handleInputChange}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <FormControl fullWidth>
            <TPTextField
              {...textFieldProps}
              name="accountNo"
              size="small"
              label="Account Number"
              placeholder="Account Number"
              value={state.accountNo}
              onChange={handleInputChange}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <FormControl fullWidth>
            <TPTextField
              {...textFieldProps}
              name="accountHolderName"
              size="small"
              label="Account Holder's Name"
              placeholder="Account Holder's Name"
              value={state.accountHolderName}
              onChange={handleInputChange}
            />
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
};

export default BankDetails;
